module.exports = __webpack_public_path__ + "static/media/shree-banner.9f09c2bd.png";